import { singlePickReachability } from './single-pick-reachability.js';
const OPTION_PREFIX = 'option_';
/** @param options the EFFECTIVE options, roles already resolved through any matched branch. */
export function dropdownReachability(d, options) {
    const r = singlePickReachability(d, options, o => `${OPTION_PREFIX}${o.id}`, trigger => trigger.startsWith(OPTION_PREFIX));
    return { states: r.states, correctOptions: r.correctItems, uncoveredWrong: r.uncoveredWrong };
}
//# sourceMappingURL=dropdown-reachability.js.map